module.exports = __webpack_public_path__ + "static/media/redInfo.1f9128f3.svg";